import React from 'react'

import './styles.scss'

const baseClass = 'chart-loader'

const ChartLoader = () => (
  <div className={`${baseClass} company-dashboard-protracks`}>
    <div className="company-dashboard-protracks__chart">
      <div className={`${baseClass}__title loader-row`} />
      <div className={`${baseClass}__chart`} />
    </div>
    <ul className={`${baseClass}__list`}>
      {[1, 2, 3, 4, 5, 6].map((item, i) => <li key={i} className={`${baseClass}__list-item loader-row`} />)}
    </ul>
  </div>
)

export default ChartLoader
